import { ErrorMessage, Layout, TileSelect, TileSelectGroup } from "@vwfs-bronson/bronson-react";
import { IMatchMakerAnswers, ISelectListItem } from "../../interfaces";
import { useFormikContext } from "formik";

type Props = {
    list: ISelectListItem<string>[];
    className?: string;
    fieldName: keyof IMatchMakerAnswers;
    showError?: boolean;
    titleParam?: string;
    required?: boolean;
};

export const TilesSelectGroup: React.FC<Props> = ({ list, className, titleParam, fieldName, showError = true, required }) => {
    const { values, errors, setFieldTouched, setFieldValue, touched } = useFormikContext<IMatchMakerAnswers>();

    const handleClickItem = () => setFieldTouched(fieldName, true);
    const handleChangeItem = (e: React.ChangeEvent<HTMLInputElement>) => {
        const target = e.currentTarget;
        let valueArray = values[fieldName] as (string | number | boolean)[];

        if (valueArray !== undefined) {
            const copiedValueArray = [...valueArray];
            if (target.checked) {
                copiedValueArray.push(target.value);
            } else {
                copiedValueArray.splice(valueArray.indexOf(target.value), 1);
            }
            valueArray = copiedValueArray;
        } else {
            valueArray = [];
            if (target.checked) {
                valueArray.push(target.value);
            } else {
                valueArray.splice(valueArray.indexOf(target.value), 1);
            }
        }

        if (valueArray.length === 0) setFieldValue(fieldName, undefined);

        setFieldValue(fieldName, valueArray);
    };

    const handleBlurItem = () => setFieldTouched(fieldName, true);

    return (
        <>
            <TileSelectGroup layoutItemClassName={className} 
                title={{
                    text: titleParam ?? ''
                }}
                required={required}>
                {list.map((x) => (
                    <TileSelect
                        aria-invalid={(showError && touched[fieldName] && errors[fieldName]) as boolean}
                        aria-errormessage={`selectableTileGroup-${fieldName}`}
                        key={fieldName + x.id}
                        icon={x.icon}
                        id={x.id}
                        value={x.value.toString()}
                        checkboxGroupName={`selectableTileGroup-${fieldName}`}
                        checked={((values[fieldName] as (string | number | boolean)[]) || []).includes(
                            x.value as string
                        )}
                        onClick={handleClickItem}
                        onChange={handleChangeItem}
                        onBlur={handleBlurItem}
                        title={<span className="u-font-size-fs0">{x.displayName}</span>}
                        aria-labelledby={`selectableTileGroup-${fieldName}`}
                    >
                        {x.description && (
                            <div className="u-text-left">
                                <br />
                                {x.description}
                            </div>
                        )}
                    </TileSelect>
                ))}
            </TileSelectGroup>
            {showError && touched[fieldName] && errors[fieldName] && (
                <Layout>
                    <Layout.Item>
                        <ErrorMessage id={`selectableTileGroup-${fieldName}`}>
                            {errors[fieldName] as string}
                        </ErrorMessage>
                    </Layout.Item>
                </Layout>
            )}
        </>
    );
};
